import { render, staticRenderFns } from "./site-internet-professionnel-comment-bien-choisir-son-nom-de-domaine.vue?vue&type=template&id=0dbb9720&"
import script from "./site-internet-professionnel-comment-bien-choisir-son-nom-de-domaine.vue?vue&type=script&lang=js&"
export * from "./site-internet-professionnel-comment-bien-choisir-son-nom-de-domaine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports